import { isDesktopScreen, isMobileView } from "../utils/screen";
import { ReactNode } from "react";

export function HiddenForMobile({ children }: { children: ReactNode }) {
  return isDesktopScreen() ? <>{children}</> : null;
}

export function VisibleOnMobile({ children }: { children: ReactNode }) {
  return isMobileView() ? <>{children}</> : null;
}
